/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppointmentTypeLightResponse } from './AppointmentTypeLightResponse';
import {
    AppointmentTypeLightResponseFromJSON,
    AppointmentTypeLightResponseFromJSONTyped,
    AppointmentTypeLightResponseToJSON,
    AppointmentTypeLightResponseToJSONTyped,
} from './AppointmentTypeLightResponse';

/**
 * Response for day model
 * @export
 * @interface DayModelContentResponse
 */
export interface DayModelContentResponse {
    /**
     * Unique identifier of the day model content
     * @type {string}
     * @memberof DayModelContentResponse
     */
    dayModelContentId?: string;
    /**
     * Start time of day model
     * @type {string}
     * @memberof DayModelContentResponse
     */
    startTime?: string;
    /**
     * End ime of day model
     * @type {string}
     * @memberof DayModelContentResponse
     */
    endTime?: string;
    /**
     * 
     * @type {AppointmentTypeLightResponse}
     * @memberof DayModelContentResponse
     */
    appointmentType?: AppointmentTypeLightResponse;
}

/**
 * Check if a given object implements the DayModelContentResponse interface.
 */
export function instanceOfDayModelContentResponse(value: object): value is DayModelContentResponse {
    return true;
}

export function DayModelContentResponseFromJSON(json: any): DayModelContentResponse {
    return DayModelContentResponseFromJSONTyped(json, false);
}

export function DayModelContentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DayModelContentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'dayModelContentId': json['dayModelContentId'] == null ? undefined : json['dayModelContentId'],
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'appointmentType': json['appointmentType'] == null ? undefined : AppointmentTypeLightResponseFromJSON(json['appointmentType']),
    };
}

export function DayModelContentResponseToJSON(json: any): DayModelContentResponse {
    return DayModelContentResponseToJSONTyped(json, false);
}

export function DayModelContentResponseToJSONTyped(value?: DayModelContentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dayModelContentId': value['dayModelContentId'],
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'appointmentType': AppointmentTypeLightResponseToJSON(value['appointmentType']),
    };
}

